/** CSV exports (orders, customers). Default export: a page; ExportOrdersButton / ExportCustomersButton are small reusable buttons. */
import React, { useState } from 'react';
import { Button, Card, DatePicker, Input, Select, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import { toastErr, useSite } from './common';


const useDownload = () => {
    const { api, site } = useSite();
    const [busy, setBusy] = useState(false);
    const run = async (kind, params) => {
        setBusy(true);
        try { await api.download(`/exports/${kind}.csv`, `${kind}-${site?.slug || 'site'}-${new Date().toISOString().slice(0, 10)}.csv`, params); } catch (e) { toastErr(e); } finally { setBusy(false); }
    };
    return { run, busy };
};

export const ExportOrdersButton = ({ params, size }) => {
    const { t } = useTranslation();
    const { run, busy } = useDownload();
    return <Button size={size} icon={<DownloadOutlined />} loading={busy} onClick={() => run('orders', params)}>{t('Export')}</Button>;
};

export const ExportCustomersButton = ({ params, size }) => {
    const { t } = useTranslation();
    const { run, busy } = useDownload();
    return <Button size={size} icon={<DownloadOutlined />} loading={busy} onClick={() => run('customers', params)}>{t('Export')}</Button>;
};

const ShopExports = () => {
    const { t } = useTranslation();
    const { run, busy } = useDownload();
    const [range, setRange] = useState(null);
    const [fin, setFin] = useState('');
    const [tag, setTag] = useState('');
    return (
        <Space direction="vertical" size={16} style={{ width: '100%', maxWidth: 760 }}>
            <Card size="small" title={t('Orders')}>
                <Space wrap>
                    <DatePicker.RangePicker value={range} onChange={setRange} />
                    <Select value={fin} onChange={setFin} style={{ width: 170 }} options={[
                        { value: '', label: t('Any payment status') }, { value: 'paid', label: t('Paid') }, { value: 'pending', label: t('Pending') },
                        { value: 'refunded', label: t('Refunded') }, { value: 'partially_refunded', label: t('Partially refunded') },
                    ]} />
                    <Input placeholder={t('Tag')} value={tag} onChange={(e) => setTag(e.target.value)} style={{ width: 140 }} />
                    <Button type="primary" icon={<DownloadOutlined />} loading={busy} onClick={() => run('orders', {
                        from: range?.[0]?.format('YYYY-MM-DD'), to: range?.[1]?.format('YYYY-MM-DD'), financial_status: fin || undefined, tag: tag || undefined,
                    })}>{t('Export CSV')}</Button>
                </Space>
            </Card>
            <Card size="small" title={t('Customers')}>
                <Button type="primary" icon={<DownloadOutlined />} loading={busy} onClick={() => run('customers')}>{t('Export CSV')}</Button>
            </Card>
        </Space>
    );
};

export default ShopExports;
